import { Truck, MapPin } from "lucide-react";

interface ShippingItem {
  name: string;
  is_pickup: number;
  count: number;
}

interface DashboardShippingBreakdownProps {
  items: ShippingItem[];
  deliveryCount: number;
  pickupCount: number;
}

export default function DashboardShippingBreakdown({ deliveryCount, pickupCount }: DashboardShippingBreakdownProps) {
  return (
    <div className="bg-white rounded-xl border border-border/60 p-5">
      <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-4">
        Način dostave
      </p>
      <div className="grid grid-cols-2 gap-4 sm:gap-6 max-w-sm">
        <div className="flex items-center gap-3 bg-muted/40 rounded-xl p-4">
          <div className="size-9 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
            <Truck className="size-4 text-blue-600" />
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium">
              Dostava
            </p>
            <p className="text-xl font-semibold tabular-nums mt-0.5">{deliveryCount}</p>
          </div>
        </div>

        <div className="flex items-center gap-3 bg-muted/40 rounded-xl p-4">
          <div className="size-9 rounded-lg bg-emerald-50 flex items-center justify-center shrink-0">
            <MapPin className="size-4 text-emerald-600" />
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium">
              Preuzimanje
            </p>
            <p className="text-xl font-semibold tabular-nums mt-0.5">{pickupCount}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
